import { useEffect, useState } from 'react';
import { getHpAllInCard } from '../cardDefinitions';
import { IFrameCardProps } from '../FrameCardTemplate';

interface Props {
  translate: any;
  language: string;
  country: string;
  hpAllInSubDifferentThanInactiveExists: boolean;
  isSubscriptionsLoading: boolean;
}

export function useLoadHpAllInCard({
  translate,
  language,
  country,
  hpAllInSubDifferentThanInactiveExists,
  isSubscriptionsLoading
}: Props): { resolved: boolean; card: IFrameCardProps | null } {
  const [resolved, setResolved] = useState(false);
  const [card, setCard] = useState<IFrameCardProps | null>(null);

  useEffect(() => {
    if (isSubscriptionsLoading) return;

    if (hpAllInSubDifferentThanInactiveExists) {
      const cardResult = getHpAllInCard(translate, country, language);
      setCard(cardResult);
    }
    setResolved(true);
  }, [
    hpAllInSubDifferentThanInactiveExists,
    translate,
    country,
    language,
    isSubscriptionsLoading
  ]);

  return { resolved, card };
}
